/**
 * defa.controllersInvitationController
 * The controller for the InvitationRouter
 * @version 1.2.0
 */
import Controller          from 'scripts/poppet/controller';
import Invitation          from 'scripts/defa/invitations/model-invitation';
import InvitationContainer from 'scripts/defa/invitations/view-invitation-container';

const channelLayout = Bb.Radio.channel( 'layout' ),
	channelNav    = Bb.Radio.channel( 'nav'    ),
	channelUser   = Bb.Radio.channel( 'user'   );

const InvitationController = Controller.extend({
		
		// ------------------------------------------------
		// Routes
		// ------------------------------------------------
		
		/**
		 * Shows the application collectionView-interface
		 * @void
		 */
	showInvitationsWithToken: function (context, email, token) {
		let invitation = new Invitation();
		context = 'user:' + ( context || 'create' );
		
		this.listenToOnce( invitation, 'sync', function() {
			this.stopListening( invitation, 'error' );
			this.attachInvitationContainer({
				view      : 'invitations:token',
				context : context,
				email : email,
				token : token,
				invitation  : invitation,
				sync         : false,
				noLogin      : true,
				closeLink : {
					event: 'app:home',
				},
			});
			
		});
		
		this.listenToOnce( invitation, 'error', function(model, response) {
			this.stopListening( invitation, 'sync' );
			channelLayout.trigger( 'error', response.responseJSON );
		});
		
		invitation.fetch({
			data: {
				token : token,
			},
			processData: true,
		});
	},
		
		
		
		/**
		 * Create and display a SubscriptionContainer.
		 * @param {Object} options  An object containing all the needed objects for creating, listing and editing Unit-information.
		 * @void
		 */
	attachInvitationContainer: function( options ) {
		
		options           = options           || {};
		options.user      = options.user      || channelUser.request( 'model' );
		options.noLogin   = options.noLogin   || false;
		options.closeLink = options.closeLink || {
			event  : 'app:home',
		};
			
			// if user isn't logged in, and this view isn't a no-login view, route to search.
		if ( channelUser.request( 'is:logged:out' ) && ! options.noLogin ) {
			channelNav.trigger( 'user:login', { trigger: true, replace: true, });
				
				
				// if the user is logged in, play with the subscriptionContainer.
		} else {
			
			let self = options.self || this;
				
				// if the SubscriptionContainer isn't made or is destroyed, create it and attach it's listeners
			if ( ! ( self.invitationContainer instanceof InvitationContainer ) || self.invitationContainer.isDestroyed() ) {
				self.invitationContainer = new InvitationContainer( options );
					
					// if it already exists, just update it's options
			} else {
				self.invitationContainer.settings( options );
			}
				
				// if the container isn't attached yet, attach it to the DOM
			if ( ! self.invitationContainer.isAttached() ) {
				channelLayout.request( 'root' ).showChildView( 'main', self.invitationContainer );
			}
		}
	},
	
});

export default InvitationController;
